import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aslcontact',
  templateUrl: './aslcontact.component.html',
  styleUrls: ['./aslcontact.component.scss']
})
export class AslcontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
